import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Container, Row, Col, Table } from 'react-bootstrap';
import './TrackResults.css';
import Footer from '../Footer/Footer';
import { AwbApi } from '../../Services/AwbService';
import { useSelector } from 'react-redux';

const TrackResults = () => {
  const location = useLocation();
  const history = useHistory();
  const { trackingData } = location.state || {};
  const [newTrackingNumber, setNewTrackingNumber] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const searchInputRef = useRef(null);
  const url=useSelector((state) => state.url);

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  if (!trackingData) {
    history.push('/');
    return null;
  }

  const handleNewSearch = async () => {
    if (!newTrackingNumber.trim()) {
      alert('Please enter a tracking number');
      return;
    }

    const cleanNumber = newTrackingNumber.trim().replace(/[-\s]/g, '');
    if (cleanNumber.length !== 11 && cleanNumber.length !== 12) {
      alert('Please enter a valid Air Waybill number (11-12 digits)');
      return;
    }

    if (!/^[0-9]+$/.test(cleanNumber)) {
      alert('Please enter a valid Air Waybill number (numbers only)');
      return;
    }

    setIsSearching(true);
    try {
      const formattedAwb = cleanNumber.length === 12 
        ? cleanNumber.substring(0, 3) + cleanNumber.substring(4) 
        : cleanNumber;

      const response = await AwbApi(formattedAwb,url);
      
      if (response.data.statusCode === 200 && response.data.success) {
        const trackingData = JSON.parse(response.data.data);
        history.push('/track-results', {
          trackingData,
          trackingNumber: newTrackingNumber.trim()
        });
        setNewTrackingNumber('');
      } else {
        history.push('/track-results', {
          trackingData: { error: 'AWB not found or invalid number' },
          trackingNumber: newTrackingNumber.trim()
        });
      }
    } catch (error) {
      console.error('Tracking error:', error);
      history.push('/track-results', {
        trackingData: { error: 'Unable to retrieve tracking information. Please try again later.' },
        trackingNumber: newTrackingNumber.trim()
      });
    } finally {
      setIsSearching(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleNewSearch();
    }
  };

  let data, error = null;
  let pageData = null;

  // Parse the JSON data from the API response
  try {
    if (typeof trackingData === 'string') {
      pageData = JSON.parse(trackingData);
    } else {
      pageData = trackingData;
    }
    
    if (pageData && pageData["RESPONSE"] && pageData["RESPONSE"]["ECTSTA-OUT"]) {
      data = pageData["RESPONSE"]["ECTSTA-OUT"][0];
      error = pageData["RESPONSE"]["ECTSTA-OUT"][0].hasOwnProperty("SVCERROR");
    } else {
      error = true;
    }
  } catch (e) {
    console.error('Error parsing tracking data:', e);
    error = true;
  }

  // Process status history like in the working file
  const all_status = [];
  const summary = [];
  const temp_arr = [];
  const garvage = [];
  let temp_len = [];
  let status = null;
  let piece = null;
  let s_val, temp = "";

  const val = [
    "PICKUP",
    "CHECKED", 
    "ASSIGNED",
    "ACCEPTED",
    "MISSING",
    "ARRIVED",
    "AVAILABLE", 
    "DEPARTED",
    "DELIVERED",
  ];

  if (error != null && !error && data && data["HISTORY"] && data["HISTORY"][0] && data["HISTORY"][0]["ENTRY"]) {
    data["HISTORY"][0]["ENTRY"]?.map((info, key) => {
      if (info.hasOwnProperty("AGENT")) {
        for (let a of val) {
          if (info["STATUS"][0].toUpperCase().includes(a)) {
            status = a == "PICKUP" ? "available" : a == "CHECKED" ? "arrived" : a;
            break;
          }
        }
        
        if (
          info["STATUS"][0].toUpperCase().includes("FROM") ||
          info["STATUS"][0].toUpperCase().includes("ASSIGNED")
        ) {
          s_val = info["STATUS"][0].substring(
            info["STATUS"][0].indexOf("--") + 3
          );
          if (info["STATUS"][0].toUpperCase().includes("PIECE")) {
            temp = info["STATUS"][0].substring(
              0,
              info["STATUS"][0].indexOf("PIECES")
            );
            piece = temp.includes("--")
              ? temp.substring(temp.indexOf("--") + 3)
              : temp.substring(0);
          } else {
            piece = "0";
          }
        } else {
          if (info["STATUS"][0].toUpperCase().includes("PIECE")) {
            temp = info["STATUS"][0].substring(
              0,
              info["STATUS"][0].indexOf("PIECES")
            );
            piece = temp.includes("--")
              ? temp.substring(temp.indexOf("--") + 3)
              : temp.substring(0);
          } else {
            piece = "0";
          }

          s_val = `${piece} pieces ${status?.toLowerCase()} at ${
            info["STATION"][0]
          }, ${info["LOCAL"][0]["DATE"][0].substring(0, 2)} ${info["LOCAL"][0][
            "DATE"
          ][0].substring(2)} ${info["LOCAL"][0]["TIME"][0].substring(
            0,
            2
          )}:${info["LOCAL"][0]["TIME"][0].substring(2)}`;
        }
        
        all_status.push({
          status: s_val,
          key: info["STATION"][0],
          val: status?.toUpperCase(),
          date: info["LOCAL"][0]["DATE"][0],
          time: info["LOCAL"][0]["TIME"][0],
          piece: piece,
          original: info["STATUS"][0],
        });
      }
    });
  }

  // Process summary similar to working file
  if (all_status.length > 0) {
    for (let i = all_status.length - 1; i >= 0; i--) {
      if (all_status[i].piece != "0") temp_arr.push(all_status[i]);
    }
  }

  if (temp_arr.length > 0) {
    for (let i = 0; i < temp_arr.length; i++) {
      temp_len = [];
      if (!garvage.includes(i)) {
        let tem = "";

        if (
          temp_arr[i].original.includes("DEPARTED FROM") ||
          temp_arr[i].original.includes("PICKUP")
        ) {
          tem = temp_arr[i].original.substring(
            temp_arr[i].original.indexOf("PIECES") + 6
          );
        } else {
          tem = temp_arr[i].original.substring(
            temp_arr[i].original.indexOf("PIECES") + 6,
            temp_arr[i].original.indexOf(temp_arr[i].key) + 3
          );
        }

        for (let j = 0; j < temp_arr.length; j++) {
          let tem1 = "";
          if (!garvage.includes(j) && i != j) {
            if (
              temp_arr[j].original.includes("DEPARTED FROM") ||
              temp_arr[j].original.includes("PICKUP")
            ) {
              tem1 = temp_arr[j].original.substring(
                temp_arr[j].original.indexOf("PIECES") + 6
              );
            } else {
              tem1 = temp_arr[j].original.substring(
                temp_arr[j].original.indexOf("PIECES") + 6,
                temp_arr[j].original.indexOf(temp_arr[j].key) + 3
              );
            }
            if (tem1 === tem) {
              temp_len.push({ i: i, j: j });
            }
          }
        }
        
        var pcs = 0;
        if (temp_len.length > 0) {
          for (var match of temp_len) {
            pcs = parseInt(temp_arr[match.j].piece) + pcs;
            if (!garvage.includes(match.j)) garvage.push(match.j);
          }
          pcs = parseInt(temp_arr[match.i].piece) + pcs;
          summary.push(
            pcs +
              " " +
              temp_arr[match.j].status.substring(
                temp_arr[match.j].status.toUpperCase().indexOf("PIECES")
              )
          );
        } else {
          summary.push(temp_arr[i].status);
          if (!garvage.includes(i)) garvage.push(i);
        }
      }
    }
  }

  return (
    <>
    {/* Page Header */}
    <div style={{
      backgroundColor: 'white',
      padding: '40px 0',
      borderBottom: '1px solid #e9ecef',
    //   marginBottom: '30px'
    }}>
      <Container>
        <Row>
          <Col xs="12">
            <h1 style={{
              fontSize: '2rem',
              fontWeight: '800',
              color: '#00238a',
            //   textAlign: 'center',
              margin: '0',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              fontFamily:"Scandinavian New"
            }}>
              TRACK AND TRACE
            </h1>
          </Col>
        </Row>
      </Container>
    </div>

    <div className="track-results-container">
      <Container>
        <Row>
          <Col xs="12" md="12">
            {/* {error ? (
              <>
                <div className="shipment-card">
                  <div className="shipment-header">
                    <h2 className="shipment-title">SHIPMENT DETAILS</h2>
                  </div>
                  <div className="shipment-content">
                    <div className="error-section text-center">
                      <div className="error-icon">⚠️</div>
                      <h3>AWB DOES NOT EXIST</h3>
                      <p>AWB does not exist. Please insert a valid number</p>
                      <div style={{ 
                        marginTop: '20px',
                        display: 'flex',
                        gap: '10px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '500px',
                        margin: '20px auto 0'
                      }}>
                        <input
                          ref={searchInputRef}
                          type="text"
                          placeholder="Enter AWB number"
                          value={newTrackingNumber}
                          onChange={(e) => setNewTrackingNumber(e.target.value)}
                          onKeyPress={handleKeyPress}
                          disabled={isSearching}
                          maxLength="12"
                          style={{
                            flex: '1',
                            padding: '12px 16px',
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            fontSize: '0.95rem',
                            outline: 'none',
                            transition: 'border-color 0.3s ease'
                          }}
                        />
                        <button 
                          onClick={handleNewSearch}
                          disabled={isSearching}
                          style={{
                            backgroundColor: isSearching ? '#666' : '#00238a',
                            color: 'white',
                            border: 'none',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            cursor: isSearching ? 'not-allowed' : 'pointer',
                            transition: 'all 0.3s ease',
                            minWidth: '100px'
                          }}
                        >
                          {isSearching ? 'Searching...' : 'Search'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : ( */}
              <>
                {/* Shipment Overview Card */}
                <div className="shipment-card">
                  <div className="shipment-header">
                    <h2 className="shipment-title">SHIPMENT DETAILS</h2>
                    <span className="status-badge-header in-transit">In Transit</span>
                  </div>
                  <div className="shipment-content">
                    <div className="shipment-grid">
                      <div className="shipment-item">
                        <div className="item-label">Air Waybill</div>
                        <div className="item-value awb-number">
                          {data && data["DETAIL"] && data["DETAIL"][0] && data["DETAIL"][0]["AWB-INFO"] && data["DETAIL"][0]["AWB-INFO"][0]["AWB"] 
                            ? data["DETAIL"][0]["AWB-INFO"][0]["AWB"][0] : 'N/A'}
                        </div>
                      </div>
                      
                      <div className="shipment-item">
                        <div className="item-label">Origin</div>
                        <div className="item-value">
                          {data && data["DETAIL"] && data["DETAIL"][0] && data["DETAIL"][0]["AWB-INFO"] && data["DETAIL"][0]["AWB-INFO"][0]["ROUTING"] && data["DETAIL"][0]["AWB-INFO"][0]["ROUTING"][0]["ORIGIN"]
                            ? data["DETAIL"][0]["AWB-INFO"][0]["ROUTING"][0]["ORIGIN"][0]["STATION"] : 'N/A'}
                        </div>
                      </div>
                      
                      <div className="shipment-item">
                        <div className="item-label">Destination</div>
                        <div className="item-value">
                          {data && data["DETAIL"] && data["DETAIL"][0] && data["DETAIL"][0]["AWB-INFO"] && data["DETAIL"][0]["AWB-INFO"][0]["ROUTING"] && data["DETAIL"][0]["AWB-INFO"][0]["ROUTING"][0]["DEST"]
                            ? data["DETAIL"][0]["AWB-INFO"][0]["ROUTING"][0]["DEST"][0]["STATION"] : 'N/A'}
                        </div>
                      </div>
                      
                      <div className="shipment-item">
                        <div className="item-label">Product</div>
                        <div className="item-value">
                          {data && data["DETAIL"] && data["DETAIL"][0] && data["DETAIL"][0]["AWB-INFO"] && data["DETAIL"][0]["AWB-INFO"][0]["PROD-DESC"]
                            ? data["DETAIL"][0]["AWB-INFO"][0]["PROD-DESC"][0] : 'N/A'}
                        </div>
                      </div>
                      
                      <div className="shipment-item">
                        <div className="item-label">Pieces</div>
                        <div className="item-value">
                          {data && data["DETAIL"] && data["DETAIL"][0] && data["DETAIL"][0]["AWB-INFO"] && data["DETAIL"][0]["AWB-INFO"][0]["TWTOTALS"] && data["DETAIL"][0]["AWB-INFO"][0]["TWTOTALS"][0]["PCS"]
                            ? data["DETAIL"][0]["AWB-INFO"][0]["TWTOTALS"][0]["PCS"][0] : 'N/A'}
                        </div>
                      </div>
                      
                      <div className="shipment-item">
                        <div className="item-label">Weight(Kg)</div>
                        <div className="item-value">
                          {data && data["DETAIL"] && data["DETAIL"][0] && data["DETAIL"][0]["AWB-INFO"] && data["DETAIL"][0]["AWB-INFO"][0]["TWTOTALS"] && data["DETAIL"][0]["AWB-INFO"][0]["TWTOTALS"][0]["WGT"]
                            ? data["DETAIL"][0]["AWB-INFO"][0]["TWTOTALS"][0]["WGT"][0] : 'N/A'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Placeholder for other sections - to be refactored later */}
                

                {/* Status/History Summary */}
                {summary && summary.length > 0 && (
                  <div className="shipment-card">
                    <div className="shipment-header">
                      <h2 className="shipment-title">
                        {/* <i className="fas fa-history me-2"></i> */}
                        STATUS / HISTORY
                      </h2>
                      <span className="status-count">{summary.length} Events</span>
                    </div>
                    
                    <div className="shipment-content">
                      <div className="status-timeline">
                      {summary.map((status, index) => (
                        <div key={index} className={`status-card ${index === 0 ? 'latest' : ''}`}>
                          <div className="timeline-connector">
                            <div className="timeline-dot">
                              <i className={`fas ${index === 0 ? 'fa-clock' : 'fa-check'}`}></i>
                            </div>
                            {index < summary.length - 1 && <div className="timeline-line"></div>}
                          </div>
                          
                          <div className="status-content">
                            <div className="status-row">
                              <span className="status-badge-simple">
                                {index === 0 ? 'LATEST' : `Step ${summary.length - index}`}
                              </span>
                              <span className="status-description-inline">
                                {status}
                              </span>
                              <span className="pieces-badge-inline">
                                <i className="fas fa-box me-1"></i>
                                {status.match(/\d+/)?.[0] || '0'} pieces
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    </div>
                  </div>
                )}

                {/* Detailed Status History */}
                {all_status && all_status.length > 0 && (
                  <div className="shipment-card">
                    <div className="shipment-header">
                      <h2 className="shipment-title">
                        <i className="fas fa-shipping-fast me-2"></i>
                        TRACK & TRACE SHIPMENT HISTORY
                      </h2>
                      <div className="history-stats">
                        <span className="history-count">{all_status.length} Events</span>
                        <span className="history-period">Complete Journey</span>
                      </div>
                    </div>
                    
                    <div className="shipment-content">
                      <div className="professional-table-container">
                      <table className="professional-table">
                        <thead style={{ background: '#f8f9fa', color: '#495057' }}>
                          <tr>
                            <th className="table-header-number" style={{ background: '#f8f9fa', color: '#495057' }}>#</th>
                            <th className="table-header-status" style={{ background: '#f8f9fa', color: '#495057' }}>Status</th>
                            <th className="table-header-time" style={{ background: '#f8f9fa', color: '#495057' }}>Date & Time</th>
                            <th className="table-header-station" style={{ background: '#f8f9fa', color: '#495057' }}>Station</th>

                          </tr>
                        </thead>
                        <tbody>
                          {all_status.map(({ status, key, date, time, piece }, index) => (
                            <tr key={index} className={`table-row ${index === 0 ? 'latest-row' : ''}`}>
                              <td className="table-cell-number">
                                <span className="row-number">{index + 1}</span>
                              </td>
                              <td className="table-cell-status">
                                <div className="status-content">
                                  <span className={`status-indicator ${index === 0 ? 'active' : 'completed'}`}></span>
                                  <span className="status-text">{status}</span>
                                </div>
                              </td>
                             
                              <td className="table-cell-time">
                                {date && time ? (
                                  <div className="time-display">
                                    <span style={{fontFamily:"Scandinavian New"}} className="date-part">{date.substring(0, 2)}/{date.substring(2)}</span>
                                    <span className="time-part">{time.substring(0, 2)}:{time.substring(2)}</span>
                                  </div>
                                ) : (
                                  <span className="time-na">Time N/A</span>
                                )}
                              </td>
                               <td className="table-cell-station">
                                <div style={{fontFamily:"Scandinavian New"}} className="station-badge">
                                  <i style={{fontFamily:"Scandinavian New"}} className="fas fa-map-marker-alt me-1"></i>
                                  {key}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    </div>
                  </div>
                )}
              </>
            {/* )} */}
          </Col>
        </Row>
      </Container>
      
    </div>
            <Footer/>

    </>
  );
};

export default TrackResults;